import { Pricing } from "@/components/sections/Pricing";
import { SEO } from "@/components/SEO";

export default function Subscription() {
  return (
    <>
      <SEO 
        title="Subscription - WillTheyConvert"
        description="Get access to all features and start validating your startup ideas today."
      />
      <div className="min-h-screen bg-background">
        <Pricing />
      </div>
    </>
  );
} 